import {RapidNeighborJoining} from 'neighbor-joining';

export function parseFasta(raw, fileName) {
  let sequences = [];
  let unnamedNum = 0;
  for (let rawseq of raw.split(/^(?=>)/gm)) {
    let header, size;
    let sequence = [];

    for (let line of rawseq.split(/[\r\n]+/g)) {
      if (line.startsWith('#')) {
        continue;
      }
      else if (line.startsWith('>')) {
        header = header || line.slice(1).trim();
      }
      else {
        sequence.push(line.trim());
      }
    }
    sequence = sequence.join('');
    size = sequence.length;
    if (header === undefined) {
      if (size) {
        header = `${fileName} unamed sample: ${++ unnamedNum}`;
        header = header.trim();
      }
      else {
        // ignore if header and sequence are both empty
        continue;
      }
    }
    sequences.push({header, sequence, size});
  }
  return sequences;
}

export function concatFasta(header, sequence) {
  if (header instanceof Array) {
    return header
      .map(({header, sequence}) => concatFasta(header, sequence))
      .join('\n');
  }
  else {
    return `>${header}\n${sequence}`;
  }
}

function calcDistance(seq1, seq2) {
  const seqLen = seq1.length;
  let distance = 0;
  const ignores = /[N.-]/;
  for (let i = 0; i < seqLen; i ++) {
    const na1 = seq1[i];
    const na2 = seq2[i];
    if (ignores.test(na1) || ignores.test(na2)) {
      continue;
    }
    distance += na1 !== na2;
  }
  return distance / seqLen;
}

function calcDistanceMatrix(seqs) {
  const matrix = new Array(seqs.length).fill(0)
    .map(() => new Array(seqs.length).fill(0));
  const seqsCount = seqs.length;
  for (let i = 0; i < seqsCount; i ++) {
    const {sequence: si} = seqs[i];
    for (let j = i + 1; j < seqsCount; j ++) {
      const {sequence: sj} = seqs[j];
      const dist = calcDistance(si, sj);
      matrix[i][j] = matrix[j][i] = dist;
    }
  }
  return matrix;
}

export function asNewick(seqs) {
  const matrix = calcDistanceMatrix(seqs);
  const taxa = seqs.map(({header: name}) => ({name}));
  const rnj = new RapidNeighborJoining(matrix, taxa);
  rnj.run();
  return rnj.getAsNewick();
}



// WEBPACK FOOTER //
// ./src/utils/fasta.js